var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-gray container-fix-padding", attrs: { fluid: "" } },
    [
      _vm.exam
        ? [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("v-breadcrumbs", {
                      staticClass: "p-0",
                      attrs: { items: _vm.breadcrumbs },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "v-col",
                  { attrs: { lg: "12" } },
                  [
                    _c("p", { staticClass: "text-h5 mb-4" }, [
                      _vm._v(
                        _vm._s(_vm.exam.name) +
                          "を購入する【" +
                          _vm._s(_vm.exam.price.toLocaleString()) +
                          "円 + 税金" +
                          _vm._s(_vm.exam.purchaseTax.toLocaleString()) +
                          "円 " +
                          _vm._s(_vm.getDiscount) +
                          "= " +
                          _vm._s(_vm.purchasePrice.toLocaleString()) +
                          "円】"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.exam.price > 0 && _vm.exam.isUseCoupon
                      ? [
                          _c("label", [_vm._v("クーポン")]),
                          _vm._v(" "),
                          _c("div", [
                            _vm.isShowSuccess
                              ? _c("label", { staticClass: "coupon-success" }, [
                                  _vm._v("クーポンを使用しています。"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowFail
                              ? _c("label", { staticClass: "fail" }, [
                                  _vm._v(
                                    "クーポンが無効になっていますので、再度確認ください"
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.couponCode,
                                  expression: "couponCode",
                                },
                              ],
                              staticClass: "form-control",
                              domProps: { value: _vm.couponCode },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.couponCode = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group-btn d-flex mt-2 mb-2" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "form-control mr-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getCoupon()
                                    },
                                  },
                                },
                                [_vm._v("適用")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "form-control ml-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelCoupon()
                                    },
                                  },
                                },
                                [_vm._v("キャンセル")]
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "下記の受講規約をご確認いただき、同意の上お申込みください。"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("TermInUse"),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      attrs: {
                        label: "受講規約に同意します",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.hasAgreed,
                        callback: function ($$v) {
                          _vm.hasAgreed = $$v
                        },
                        expression: "hasAgreed",
                      },
                    }),
                    _vm._v(" "),
                    _vm.hasAgreed
                      ? [
                          _c("card", {
                            staticClass: "stripe-card my-4",
                            class: { complete: _vm.complete },
                            attrs: {
                              options: {
                                hidePostalCode: true,
                              },
                              stripe: _vm.exam.stripePublishableKey,
                            },
                            on: {
                              change: function ($event) {
                                _vm.complete = $event.complete
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                dark: "",
                                disabled: !_vm.canClick,
                              },
                              on: { click: _vm.purchase },
                            },
                            [_vm._v("カード決済する")]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }